export const SEND_CHAT_MESSAGE = 'app/Chat/SEND_CHAT_MESSAGE'
export const SEND_CHAT_MESSAGE_SUCCESS = 'app/Chat/SEND_CHAT_MESSAGE_SUCCESS'
export const SEND_CHAT_MESSAGE_ERROR = 'app/Chat/SEND_CHAT_MESSAGE_ERROR'

export const TOKEN_LIMIT_EXCEEDED = 'TOKEN_LIMIT_EXCEEDED'
export const CHAT_SERVICE_UNAVAILABLE = 'CHAT_SERVICE_UNAVAILABLE'
export const CHAT_TIMEOUT = 'CHAT_TIMEOUT'
export const CHAT_ANSWER_TRUNCATED = 'CHAT_ANSWER_TRUNCATED'
export const UNAUTHORIZED = 'UNAUTHORIZED'
export const FORBIDDEN = 'FORBIDDEN'
export const INVALID_INPUT = 'INVALID_INPUT'
export const CONVERSATION_NOT_FOUND = 'CONVERSATION_NOT_FOUND'
export const MISSING_CUSTOMER_CONTEXT = 'MISSING_CUSTOMER_CONTEXT'
export const MISSING_COMPANY_CONTEXT = 'MISSING_COMPANY_CONTEXT'
export const INTERNAL_ERROR = 'INTERNAL_ERROR'
export const NETWORK_ERROR = 'NETWORK_ERROR'

// Maps backend MessageKey values to frontend error codes
export const MESSAGE_KEY_TO_CODE = {
  'chat.error.tokenLimitExceeded': TOKEN_LIMIT_EXCEEDED,
  'chat.error.serviceUnavailable': CHAT_SERVICE_UNAVAILABLE,
  'chat.error.unauthorized': UNAUTHORIZED,
}
export const SEND_CHAT_MESSAGE_STATUS = 'app/Chat/SEND_CHAT_MESSAGE_STATUS'
export const SEND_CHAT_MESSAGE_STREAM_CHUNK =
  'app/Chat/SEND_CHAT_MESSAGE_STREAM_CHUNK'

export const CLEAR_CHAT_HISTORY = 'app/Chat/CLEAR_CHAT_HISTORY'
export const TOGGLE_CHAT_WINDOW = 'app/Chat/TOGGLE_CHAT_WINDOW'
export const SET_CHAT_WINDOW_OPEN = 'app/Chat/SET_CHAT_WINDOW_OPEN'
export const SET_CHAT_LOADING = 'app/Chat/SET_CHAT_LOADING'
export const SET_CONVERSATION_ID = 'app/Chat/SET_CONVERSATION_ID'

export const LOAD_CONVERSATIONS = 'app/Chat/LOAD_CONVERSATIONS'
export const LOAD_CONVERSATIONS_SUCCESS = 'app/Chat/LOAD_CONVERSATIONS_SUCCESS'
export const LOAD_CONVERSATIONS_ERROR = 'app/Chat/LOAD_CONVERSATIONS_ERROR'

export const LOAD_CONVERSATION = 'app/Chat/LOAD_CONVERSATION'
export const LOAD_CONVERSATION_SUCCESS = 'app/Chat/LOAD_CONVERSATION_SUCCESS'
export const LOAD_CONVERSATION_ERROR = 'app/Chat/LOAD_CONVERSATION_ERROR'

export const DELETE_CONVERSATION = 'app/Chat/DELETE_CONVERSATION'
export const DELETE_CONVERSATION_SUCCESS =
  'app/Chat/DELETE_CONVERSATION_SUCCESS'
export const DELETE_CONVERSATION_ERROR = 'app/Chat/DELETE_CONVERSATION_ERROR'

export const UPDATE_CONVERSATION_TITLE = 'app/Chat/UPDATE_CONVERSATION_TITLE'

export const RESET_CHAT_SCOPE = 'app/Chat/RESET_CHAT_SCOPE'

export const SET_CHAT_FULLSCREEN = 'app/Chat/SET_CHAT_FULLSCREEN'
